module.exports = __webpack_public_path__ + "static/menu_bg.de35f5f7.svg";